module.exports = __webpack_public_path__ + "static/media/dice-three.db07f4b1.svg";